import { render, staticRenderFns } from "./ProfilePrefferences.vue?vue&type=template&id=bb1d3ec6"
import script from "./ProfilePrefferences.vue?vue&type=script&lang=js"
export * from "./ProfilePrefferences.vue?vue&type=script&lang=js"
import style0 from "./ProfilePrefferences.vue?vue&type=style&index=0&id=bb1d3ec6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports